import { TFeaturedItemType } from "../../Views/Homepage/Featured/@types";
import { analytics } from "MVVM/Analytics";
export const analyticsClickEvent = (type: TFeaturedItemType, name?: string) => {
  switch (type) {
    case "promotion":
      analytics.track("Promotion - Button Click", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "motw":
      analytics.track("Montage of the Week - Button Click", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "cotd":
      analytics.track("Clip of the Day - Button Click", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    default:
      break;
  }
};

export const analyticsSlideEvent = (type: TFeaturedItemType, name?: string) => {
  switch (type) {
    case "promotion":
      analytics.track("Promotion - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "motw":
      analytics.track("Montage of the Week - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "cotd":
      analytics.track("Clip of the Day - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    default:
      break;
  }
};
